var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.583 6.792c-3.25 0-5.416 1.625-5.416 5.416v7.584c0 3.791 2.166 5.416 5.416 5.416h10.834c3.25 0 5.416-1.625 5.416-5.416v-7.584c0-3.791-2.166-5.416-5.416-5.416H9.583zM7.958 19.52a.818.818 0 0 1-.812-.813v-5.416c0-.444.368-.813.812-.813.444 0 .813.369.813.813v5.416a.818.818 0 0 1-.813.813zM11.75 16A3.246 3.246 0 0 1 15 12.75 3.246 3.246 0 0 1 18.25 16 3.246 3.246 0 0 1 15 19.25 3.246 3.246 0 0 1 11.75 16zm10.292 3.52a.818.818 0 0 1-.813-.812v-5.416c0-.444.369-.813.813-.813.444 0 .812.369.812.813v5.416a.818.818 0 0 1-.812.813z",
    fill: "#ED1C24",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/icon-14.30bfd3b6dade5c6756fed9a145d03594.svg";
export { ForwardRef as ReactComponent };